import { idb } from "../../idb.js";

export const getIncomingMessage = async ({ id }) => {
  const connection = await idb();

  return connection.get("incomingMessages", id);
};
